export function useVariablesSearch () {

}
